export default __webpack_public_path__ + "static/media/RequestDemo.11259b2c.svg";